// src/pages/PrivacyPolicy.jsx
import React from "react";
import "../styles/privacy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>
        Serenityy Marketing Management ("us", "we", or "our") operates the
        website{" "}
        <a
          href="https://serenityy.ae"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://serenityy.ae
        </a>
        . This Privacy Policy explains how we collect, use, and protect your
        personal data when you access or interact with our services. By using
        our website, you agree to the terms of this policy.
      </p>

      <h2>Information Collection and Use</h2>
      <p>
        We collect various types of information to help us provide and improve
        our services to you.
      </p>

      <h3>Types of Data Collected</h3>
      <ul>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Cookies and Usage Data</li>
      </ul>
      <p>
        This information is collected when you fill out forms, contact us, or
        interact with our website.
      </p>

      <h3>Usage Data</h3>
      <p>
        We may collect information about how you access and use the website
        ("Usage Data"), including:
      </p>
      <ul>
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Pages visited</li>
        <li>Date and time of access</li>
        <li>Time spent on pages</li>
        <li>Device identifiers</li>
        <li>Diagnostic data</li>
      </ul>
      <p>
        This data helps us improve user experience and website functionality.
      </p>

      <h2>Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking tools to analyze website traffic and
        enhance your experience.
      </p>
      <ul>
        <li>
          <strong>Session Cookies:</strong> Essential for website functionality
        </li>
        <li>
          <strong>Preference Cookies:</strong> Remember your settings and
          preferences
        </li>
        <li>
          <strong>Security Cookies:</strong> Enhance website security
        </li>
      </ul>
      <p>
        You can adjust your browser settings to manage or reject cookies.
        Disabling cookies may limit some functionalities of the site.
      </p>

      <h2>Use of Data</h2>
      <p>We use your data for purposes such as:</p>
      <ul>
        <li>Operating and maintaining the website</li>
        <li>Responding to inquiries</li>
        <li>Improving user experience through analytics</li>
        <li>Ensuring website security and performance</li>
        <li>Complying with legal obligations</li>
      </ul>

      <h2>Data Transfers</h2>
      <p>
        Your information may be stored and processed in the United Arab Emirates
        or in other locations where we or our service providers operate. By
        submitting your data, you consent to this transfer.
      </p>
      <p>
        We take appropriate security measures to protect your personal data
        during transfer and storage.
      </p>

      <h2>Links to Other Websites</h2>
      <p>
        Our website may contain links to third-party sites not operated by us.
        We are not responsible for their content or privacy practices. Please
        review the privacy policies of those sites before providing any
        information.
      </p>

      <h2>Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have rights to access, correct,
        or delete your personal data. To make a request, please contact us at{" "}
        <a href="mailto:info@serenityy.ae">info@serenityy.ae</a>.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with a revised effective date. We encourage you to
        review this page periodically.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us:
        <br />
        Email: <a href="mailto:info@serenityy.ae">info@serenityy.ae</a>
        <br />
        Website:{" "}
        <a
          href="https://serenityy.ae"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://serenityy.ae
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
